import React, {Component} from 'react';
import {
  Button,
  CardFooter
} from 'reactstrap';


import { FaPencilAlt, FaTimes} from 'react-icons/fa';



class Botonera extends Component {


    render(){
        const {valor, ingresar, editar, cancelar } = this.props;  
        
        return (
            <CardFooter>
                {valor==='' && valor!=='repetido' &&
                <Button color="success" size="sm" onClick={ingresar}>
                Guardar
                </Button>
                }


                {valor!=='' && valor!==null && valor!==undefined &&
                <span>
                    <Button color="secondary" size="sm" className="btnlado" onClick={editar}>
                    <FaPencilAlt/> {valor!=='repetido'?'Editar':'Editar registro existente'}
                    </Button>
                    <Button outline  color="danger" size="sm" className="btnlado" onClick={cancelar}>
                    <FaTimes/> {valor!=='repetido'?'Cancelar':'Cancelar edición'}
                    </Button>
                </span>

                }
            </CardFooter>

        );

    }
};

export default Botonera;
